module.exports = __webpack_public_path__ + "3522e834806a0fa9595cc4811000654f.png";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/view/reports/warning.png
// module id = 973
// module chunks = 0